<template>
	<component :is="assetPageType" />
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import AssetDetails from './asset-details.vue';
import AssetDetailsRealEstate from './asset-details-real-estate.vue';
import { computed } from 'vue';
import type { Component as ComponentType } from 'vue';

const route = useRoute();
const router = useRouter();

const isSupportedAsset = computed((): boolean => {
	return Object.keys(route.params ?? {}).some((param) => /bondId|companyId|reitElementId|ventureFundId/g.test(param));
});

const assetPageType = computed((): ComponentType => {
	return Object.keys(route.params ?? {}).some((param) => /bondId|reitElementId/g.test(param))
		? AssetDetailsRealEstate
		: AssetDetails;
});

async function setup(): Promise<void> {
	if (!isSupportedAsset.value) {
		await router.replace({ name: '404' });
	}
}

setup();
</script>
